import React, { FC } from "react";
import { Modal, Text } from "venice-ui";
import { dictionary } from "../../untils/dictionary";
import { t } from "../../helpers/userHelper";
import { getContractName } from "../../helpers/projectHelper";
import { useStoreActions, useStoreState } from "../../store";
import { apiCall } from "../../untils/apiCall";

interface IDeleteContractModal {
  handleCancel: () => any;
  id: string;
  isOpen: boolean;
}

export const DeleteContractModal: FC<IDeleteContractModal> = ({
  handleCancel,
  id,
  isOpen,
}) => {
  const { id: orgID, contracts } = useStoreState((state) => state.organization);

  const { removeContract } = useStoreActions((actions) => actions.organization);
  const { removeContractFromUser } = useStoreActions((actions) => actions.user);
  const { deleteProjectForContract } = useStoreActions(
    (actions) => actions.projects
  );

  const deleteContract = async (contractID: string) => {
    const options = {
      orgID: orgID,
      contractID: contractID,
    };
    await apiCall("organization/removeContract", options, (response: any) => {
      // remove contract from current user (userDetails => contracts)
      // remove all projects from this contract for current user (userDetails => projects)
      removeContractFromUser(contractID);

      // remove project from deleted contract in "projects" store (proejcts)
      deleteProjectForContract(contractID);

      // remove contract from all users which used this contract (org => members)
      // remove all projects from deleted contract for all users (org => members)
      // remove contract from organization (org => contracts)
      removeContract(contractID);

      handleCancel();
    });
  };
  return (
    <Modal
      title={t(dictionary.confirmDelete)}
      labelClose={t(dictionary.cancel)}
      handleClose={handleCancel}
      handleConfirm={() => deleteContract(id)}
      labelConfirm={t(dictionary.delete)}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      <Text>{getContractName(id, contracts)}</Text>
      <Text>{t(dictionary.doYouWantDeleteContract)}</Text>
    </Modal>
  );
};
